import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 查询家政服务待办列表
export function queryStaffServ(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServPool/queryStaffServ',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 工单派单
export function poolDispatch(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServPoolUser/poolDispatch',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询家政服务人员
export function queryHousekeepingServUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServUser/queryHousekeepingServUser',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 回访工单
export function appraiseRepair(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/ownerRepair.appraiseRepair',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}